<template>
  <div>
    <!-- banner部分 -->
    <div class="banner">
      <div class="banner_box">
        <el-carousel height="500px">
          <el-carousel-item v-for="item in list" :key="item.id">
            <!-- <h3>{{ item.id }}</h3> -->
            <img :src="item.url" alt="" class="bannerImg" />
          </el-carousel-item>
        </el-carousel>
        <div class="bannerTit">
          <h1>一个平台、四个领域</h1>
          <h1>致力于解决政、企事业单位"人、财、事、物"数字化难题</h1>
        </div>
      </div>
    </div>
    <div class="conter">
      <!-- 小科平台 -->
      <div class="xkPlatform">
        <h1>小科平台</h1>
        <h3>致力于解决政、企事业单位"人、财、事、物"数字化难题</h3>
        <ul class="xkPlatform_box">
          <li>
            <img src="@/assets/zq_2.png" />
            <h2>政企引擎系统</h2>
            <h3>智慧政务一体化，稳定可靠、随需应变的政务审批引擎</h3>
            <!-- 伪类 -->
            <div class="msk1">
              <img src="@/assets/xk1.png" />
              <h2>政企引擎系统</h2>
              <h3>智能化流程引擎，快速搭建政、企事业单位工作流</h3>
              <span @click="$router.push('/ZQPlatform')">查看详情</span>
            </div>
          </li>

          <li>
            <img src="@/assets/xk_2.png" />
            <h2>政务OA办公系统</h2>
            <h3>
              通过智能化、流程化、数字化整合为用户提供低成本、高效能的协同办公平台
            </h3>
            <!-- 伪类 -->
            <div class="msk1">
              <img src="@/assets/xk2.png" />
              <h2>政务OA办公系统</h2>
              <h3>
                通过智能化、流程化、数字化整合为用户提供低成本、高效能的协同办公平台
              </h3>
              <span @click="$router.push('/ZWPlatform')">查看详情</span>
            </div>
          </li>
          <li>
            <img src="@/assets/xk_3.png" />
            <h2>业财一体化系统</h2>
            <h3>七大子系统、十五个业务流程，满足申、审、报一体化管理</h3>
            <!-- 伪类 -->
            <div class="msk1">
              <img src="@/assets/xk3.png" />
              <h2>业财一体化系统</h2>
              <h3>七大子系统、十五个业务流程，满足申、审、报一体化管理</h3>
              <span @click="$router.push('/YCPlatform')">查看详情</span>
            </div>
          </li>
          <li>
            <img src="@/assets/xk_4.png" />
            <h2>费控管理系统</h2>
            <h3>绩效预算下的行政事业单位费控一体化解决方案</h3>
            <!-- 伪类 -->
            <div class="msk1">
              <img src="@/assets/xk4.png" />
              <h2>费控管理系统</h2>
              <h3>绩效预算下的行政事业单位费控一体化解决方案</h3>
              <span @click="$router.push('/FKPlatform')">查看详情</span>
            </div>
          </li>
        </ul>
      </div>
      <!-- 智能硬件 -->
      <div class="ZnHardware">
        <h1>智能硬件</h1>
        <h3>软硬件结合，助力人机交互新创新</h3>
        <ul class="ZnHardware_box">
          <li>
            <img src="@/assets/yj1.png" />
            <h2>会议机</h2>
            <h3>大型会议记录、直播、字幕制作</h3>
            <!-- 伪类 -->
            <div class="msk1">
              <img src="@/assets/yj1.png" />
              <h2>会议机</h2>
              <h3>大型会议记录、直播、字幕制作</h3>
              <span @click="$router.push('/Machine')">查看详情</span>
            </div>
          </li>
          <li>
            <img src="@/assets/yj_2.png" />
            <h2>高拍仪</h2>
            <h3>扫描、识别、转换、输出的一站式解决方案</h3>
            <!-- 伪类 -->
            <div class="msk1">
              <img src="@/assets/yj_2.png" />
              <h2>高拍仪</h2>
              <h3>扫描、识别、转换、输出的一站式解决方案</h3>
              <span @click="$router.push('/HighShotMeter')">查看详情</span>
            </div>
          </li>
          <li>
            <img src="@/assets/yj_3.png" />
            <h2>学习机</h2>
            <h3>一对一个性化精确辅导，讲、学、练、一站式掌握知识</h3>
            <!-- 伪类 -->
            <div class="msk1">
              <img src="@/assets/yj_3.png" />
              <h2>学习机</h2>
              <h3>一对一个性化精确辅导，讲、学、练、一站式掌握知识</h3>
              <span @click="$router.push('/LearningMachine')">查看详情</span>
            </div>
          </li>
          <li>
            <img src="@/assets/yj4.png" />
            <h2>翻译笔</h2>
            <h3>识字、查词、翻译，一支笔解决全阶段学习困扰</h3>
            <!-- 伪类 -->
            <div class="msk1">
              <img src="@/assets/yj4.png" />
              <h2>翻译笔</h2>
              <h3>识字、查词、翻译，一支笔解决全阶段学习困扰</h3>
              <span @click="$router.push('/TranslationMachine')">查看详情</span>
            </div>
          </li>
          <li>
            <img src="@/assets/yj5.png" />
            <h2>录音笔</h2>
            <h3>一站式解决工作、生活中即时记录的难题</h3>
            <!-- 伪类 -->
            <div class="msk1">
              <img src="@/assets/yj5.png" />
              <h2>录音笔</h2>
              <h3>一站式解决工作、生活中即时记录的难题</h3>
              <span @click="$router.push('/VoiceRecorder')">查看详情</span>
            </div>
          </li>
          <li>
            <img src="@/assets/yj_6.png" />
            <h2>会参谋</h2>
            <h3>智能会议、无线投屏、书写白板，一站式解决方案</h3>
            <!-- 伪类 -->
            <div class="msk1">
              <img src="@/assets/yj_6.png" />
              <h2>会参谋</h2>
              <h3>智能会议、无线投屏、书写白板，一站式解决方案</h3>
              <span @click="$router.push('/WillStaff')">查看详情</span>
            </div>
          </li>
        </ul>
      </div>
      <!-- 软件解决方案 -->
      <div class="ruanjianFA">
        <h1>软件解决方案</h1>
        <div class="ruanjianFA_box">
          <img src="@/assets/ruanjian.png" alt="" />
          <div class="ruanjianTit">
            <div class="ruanjianTit_box">
              <h2>一站式专业服务，为您量身定制</h2>
              <h3>PC端 / 移动端 / H5 / 小程序</h3>
            </div>
            <span
              class="ruanjianBtn"
              @click="$router.push('/SoftwareSolutions')"
              >查看详情</span
            >
          </div>
        </div>
      </div>
      <!-- 小科金融 -->
      <div class="ruanjianFA">
        <h1>小科金融</h1>
        <div class="ruanjianFA_box">
          <div class="ruanjianTit">
            <div class="ruanjianTit_box">
              <h2>高效新零售服务平台—小科邦</h2>
              <h3>
                提供支付、分期、员工管理、订单管理、行业厂销，帮助微小企业实现渠道新零售转型和升级的saas服务工具。
              </h3>
            </div>
            <span class="ruanjianBtn" @click="goJr">查看详情</span>
          </div>
          <img src="@/assets/jingrong.png" alt="" />
        </div>
      </div>

      <h1>5年服务品牌沉淀，铸就优良口碑，政企协作信赖之选</h1>
    </div>

    <!-- 底部 -->
    <div class="footBox">
      <ul class="footCar">
        <li>
          <img src="@/assets/logo.png" alt="logo" />
          <span>服务热线:</span>
          <span>028-87500117</span>
        </li>
        <li>
          <h3>联系我们</h3>
          <span> 联系邮箱：1098591@qq.com</span>
          <span> 联系地址： </span>
          <span>（成都）高新区环球中心w5区1204—1206 189-8000-0761</span>
          <span>（西安）高新区万科金域国际A座515 186-0297-8880</span>
          <span>（昆明）官渡区知春路263号 138-8878-5544</span>
          <span>（南宁）青秀区东葛路10号2楼 157-7711-0798</span>
        </li>
        <li>
          <h3>产品服务</h3>
          <span @click="$router.push('/ZQPlatform')">政企引擎平台</span>
          <span @click="$router.push('/ZWPlatform')">政务OA办公平台</span>
          <span @click="$router.push('/YCPlatform')">业财一体化平台</span>
          <span @click="$router.push('/FKPlatform')">费控管理系统</span>
        </li>
        <li>
          <span @click="$router.push('/Machine')">会议机</span>
          <span @click="$router.push('/HighShotMeter')">高拍仪</span>
          <span @click="$router.push('/VoiceRecorder')">录音笔</span>
          <span @click="$router.push('/TranslationMachine')">翻译笔</span>
          <span @click="$router.push('/LearningMachine')">学习机</span>
          <span @click="$router.push('/WillStaff')">会参谋</span>
        </li>
        <li>
          <span @click="goFinancial">小科金融</span>
          <span @click="$router.push('/SoftwareSolutions')">软件解决方案</span>
        </li>
      </ul>
      <h4>版权所有 © 2011-2032 版权归成都科必特科技有限公司所有</h4>
      <h4 @click="goBa" class="curs">主体备案号：蜀ICP备18011273号-1</h4>
      <div class="record">
        <img src="@/assets/jh.png" alt="" />
        <span @click="gohome">川公网安备 51019002002717号</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        // { id: 2, url: require('@/assets/banner_2.jpg') },
        // { id: 3, url: require('@/assets/banner3.jpg') },
        // { id: 4, url: require('@/assets/banner4.jpg') }
        { id: 2, url: require('@/assets/jiejueBanner.png') },
        { id: 3, url: require('@/assets/jj1.jpg') },
        { id: 4, url: require('@/assets/ycBanner.png') }
      ],
      msk: false
    }
  },
  methods: {
    gohome() {
      window.open('http://www.cdkbit.cn/')
    },
    goBa() {
      window.open('https://beian.miit.gov.cn/#/Integrated/index')
    },
    on() {
      this.msk = true
    },
    goFinancial() {
      window.open('http://www.cdkbit.com/')
    },
    goJr() {
      window.open('http://www.cdkbit.com/')
    }
  }
}
</script>

<style lang="less" scoped>
.banner {
  // background: url('../assets/banner5.png');
  .banner_box {
    position: relative;
    // width: 1200px;
    width: 100%;
    margin: 0 auto;
    height: 500px;
    .bannerTit {
      color: #fff;
      position: absolute;
      top: 10%;
      z-index: 99;
      display: flex;
      flex-direction: column;
      align-items: start;
      margin: 10px;
      margin-left: 25%;
    }
  }
}
.bannerImg {
  width: 100%;
  height: 500px;
}
.conter {
  width: 1200px;
  margin: 0 auto;
  .xkPlatform {
    .xkPlatform_box {
      box-sizing: border-box;
      list-style: none;
      width: 1200px;
      height: 400px;
      border-radius: 10px;
      background-color: #f2f2f2;
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: 0;
      li {
        list-style: none;
        position: relative;
        width: 240px;
        height: 360px;
        background-color: #fff;
        border-radius: 10px;
        // color: #fff;
        img {
          width: 120px;
          margin-top: 10px;
        }
        h3 {
          text-align: left;
          padding: 0 5px;
          // margin: 8px;
        }
        .msk1 {
          width: 240px;
          height: 360px;
          background-color: #02a7f0;
          border-radius: 10px;
          position: absolute;
          top: 0;
          opacity: 0;
          display: flex;
          color: #fff;
          flex-direction: column;
          justify-content: space-around;
          align-items: center;
          span {
            height: 40px;
            width: 120px;
            border-radius: 5px;
            background-color: #fff;
            color: #1296db;
            line-height: 40px;
            cursor: pointer;
            margin-bottom: 10px;
          }
        }
      }
      li:hover .msk1 {
        opacity: 1;
      }
    }
  }
  .ZnHardware {
    .ZnHardware_box {
      box-sizing: border-box;
      list-style: none;
      width: 1200px;
      height: 400px;
      border-radius: 10px;
      background-color: #f2f2f2;
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: 0;
      li {
        list-style: none;
        position: relative;
        width: 170px;
        height: 360px;
        background-color: #fff;
        border-radius: 10px;
        // color: #fff;
        padding: 10px;
        img {
          width: 120px;
          height: 100px;
          margin-top: 10px;
        }
        h3 {
          text-align: left;
        }
        .msk1 {
          width: 170px;
          height: 360px;
          background-color: #02a7f0;
          border-radius: 10px;
          position: absolute;
          top: 0;
          opacity: 0;
          display: flex;
          flex-direction: column;
          color: #fff;
          // justify-content: space-around;
          align-items: center;
          padding: 10px;
          span {
            height: 40px;
            width: 120px;
            border-radius: 5px;
            background-color: #fff;
            color: #1296db;
            line-height: 40px;
            cursor: pointer;
          }
        }
      }
      li:hover .msk1 {
        opacity: 1;
      }
    }
  }
  .ruanjianFA {
    .ruanjianFA_box {
      border-radius: 10px;
      background-color: #f2f2f2;
      width: 1200px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      height: 260px;
      img {
        width: 500px;
        height: 240px;
      }
      .ruanjianTit {
        height: 260px;
        width: 600px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: flex-end;
        .ruanjianTit_box {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          padding-left: 10px;
          h3 {
            text-align: left;
          }
        }
        .ruanjianBtn {
          cursor: pointer;
          color: #1296db;
        }
      }
    }
  }
}
.footBox {
  background-color: #f2f2f2;
  padding-bottom: 20px;
  .footCar {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    list-style: none;
    justify-content: space-between;
    align-items: flex-start;
    padding: 20px;
    background-color: #f2f2f2;
    li {
      display: flex;
      list-style: none;
      flex-direction: column;
      align-items: flex-start;
      span {
        padding: 5px 0;
      }
    }
  }
  .footCar li:first-child {
    img {
      width: 60px;
      height: 60px;
    }
  }
  .footCar li:nth-child(3) {
    span {
      color: #1296db;
      cursor: pointer;
    }
  }
  .footCar li:nth-child(4) {
    color: #1296db;
    margin-top: 62.5px;
    cursor: pointer;
  }
  .footCar li:nth-child(5) {
    color: #1296db;
    margin-top: 62.5px;
    cursor: pointer;
  }
  .record {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 30px;
      height: 30px;
      margin-right: 5px;
    }
    span {
      cursor: pointer;
    }
  }
}
.curs {
  cursor: pointer;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>
